import React, { useEffect, useState } from "react";
import { Dropdown, Spinner } from "react-bootstrap";
import "react-toastify/dist/ReactToastify.css";
import { RiMore2Fill } from "react-icons/ri";
import { FaDownload, FaTrash } from "react-icons/fa";
import {
  GrDocument,
  GrDocumentSound,
  GrDocumentTxt,
  GrDocumentVideo,
} from "react-icons/gr";
import { formatFileSize } from "../../../utilities/ext-function";
import ImagePopup from "../../../components/imagePopup";
import { API_URL } from "../../../utilities/url";

const CardList = ({ cards, loading, onChangeData }) => {
  const [prevHeight, setPrevHeight] = useState("auto");
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [activeIndex, setActiveIndex] = useState(null);

  // Image Popup
  const [isOpen, setIsOpen] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  const openModal = (url) => {
    setImageUrl(url);
    setIsOpen(true);
  };
  const closeModal = () => setIsOpen(false);

  useEffect(() => {
    if (!loading && cards.length > 0) {
      const cardsPerRow = 6;
      const rowHeight = 150;
      const minHeight = 260;
      const rows = Math.ceil(cards.length / cardsPerRow);
      setPrevHeight(`${Math.max(rows * rowHeight, minHeight)}px`);
    }
  }, [loading, cards]);

  const [rows, setRows] = useState([
    {
      name: null,
      type: "string",
      description: null,
      enum: [],
      required: false,
    },
  ]);

  const handleCardClick = (data) => {
    const datas = {
      name: data.name.replace(/\s+/g, ""),
      description: data.description,
      parameters: rows,
      active: "Y",
      exec_type: "api",
      endpoint: data.url_path,
      method: "GET",
      headers: null,
      body_type: "form-data",
      body: null,
      credentials: null,
      response_filter: null,
      response_prompt: null,
      response_media_type: null,
      response_media_url: null,
    };
    // console.log(datas);
    onChangeData(datas);
  };

  return (
    <>
      {!loading ? (
        cards.length > 0 ? (
          <div
            className="d-flex flex-wrap"
            style={{
              gap: "1.25rem",
              marginRight: "-20px",
              minHeight: prevHeight,
            }}
          >
            {cards.map((card, index) => (
              <div
                key={index}
                className="col-md-2 folder-card"
                onMouseEnter={() => setHoveredIndex(index)}
                onMouseLeave={() => setHoveredIndex(null)}
              >
                <div
                  className="card card-list shadow-lg mb-0"
                  style={{
                    cursor: "pointer",
                    backgroundColor:
                      activeIndex === index
                        ? "rgba(0, 0, 0, 0.1)"
                        : hoveredIndex === index
                        ? "rgba(0, 0, 0, 0.02)"
                        : "#fff",
                    transition: "background-color 0.2s ease",
                  }}
                  onClick={() => handleCardClick(card)}
                >
                  <div className="card-body">
                    <div className="text-start">
                      <div className="mb-2">
                        {card.media_type === "image" && (
                          <div className="square-container">
                            <img
                              src={card.url_path}
                              className="border border-2 rounded-4 cursor-pointer"
                              alt={index}
                              onClick={() => openModal(card.url_path)}
                            />
                          </div>
                        )}
                        {card.media_type === "document" && (
                          <div className="square-container">
                            <div className="c-progress d-flex justify-content-center align-items-center border border-2 rounded-4">
                              <GrDocument size={40} />
                            </div>
                          </div>
                        )}
                        {card.media_type === "text" && (
                          <div className="square-container">
                            <div className="c-progress d-flex justify-content-center align-items-center border border-2 rounded-4">
                              <GrDocumentTxt size={40} />
                            </div>
                          </div>
                        )}
                        {card.media_type === "audio" && (
                          <div className="square-container">
                            <div className="c-progress d-flex justify-content-center align-items-center border border-2 rounded-4">
                              <GrDocumentSound size={40} />
                            </div>
                          </div>
                        )}
                        {card.media_type === "video" && (
                          <div className="square-container">
                            <div className="c-progress d-flex justify-content-center align-items-center border border-2 rounded-4">
                              <GrDocumentVideo size={40} />
                            </div>
                          </div>
                        )}
                      </div>
                      <div style={{ height: "36px" }}>
                        <h6 className="fs-12 fw-bold text-ellipsis-2-line">
                          {card.name}
                        </h6>
                      </div>
                    </div>
                    <hr className="m-0 mb-2" />
                    <p className="text-dark text-start fs-12 mb-0">
                      {formatFileSize(card.filesize)}
                    </p>
                    <p className="text-dark text-start fs-12 mb-0">
                      {card.media_type}/{card.extension}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="d-flex justify-content-center align-items-center my-2">
            <p className="fs-14">No Data</p>
          </div>
        )
      ) : (
        <div
          className="d-flex justify-content-center align-items-center my-2"
          style={{ minHeight: prevHeight }}
        >
          <Spinner animation="border" />
        </div>
      )}
      <ImagePopup isOpen={isOpen} imageUrl={imageUrl} closeModal={closeModal} />
    </>
  );
};

export default CardList;
